'use client'

import { useTranslations } from 'next-intl'

import type { ModelsPlatformStatsResponse } from '@/api/generated-api'
import HeroStatsBand from '@/app/[locale]/components/HeroStatsBand'
import { formatStatValue } from '@/features/stats/format'
import { usePlatformStats } from '@/features/stats/hooks'

const FALLBACK = {
  clubs: '40+',
  fans: '50K+',
  countries: '20+'
}

const ForClubsStatsBar = ({
  initialStats
}: {
  initialStats?: ModelsPlatformStatsResponse
}) => {
  const t = useTranslations('forClubsPage.hero')
  const { data } = usePlatformStats(initialStats)

  const items = [
    {
      value: data ? formatStatValue(data.active_clubs_count) : FALLBACK.clubs,
      captionLines: [t('statLabel1Top'), t('statLabel1Bottom')]
    },
    {
      value: data ? formatStatValue(data.active_fans_count) : FALLBACK.fans,
      captionLines: [t('statLabel2Top'), t('statLabel2Bottom')]
    },
    {
      value: data ? formatStatValue(data.countries_count) : FALLBACK.countries,
      captionLines: [t('statLabel3Top')]
    },
    {
      value: '$0',
      captionLines: [t('statLabel4Top'), t('statLabel4Bottom')]
    }
  ]

  return <HeroStatsBand items={items} variant="forClubs" />
}

export default ForClubsStatsBar
